import { createAction, props } from '@ngrx/store';

const COUNTRY = 'Country';

export const setCurrentCountry = createAction(`[${COUNTRY}] Set Current Country`);
export const setCurrentCountrySuccess = createAction(`[${COUNTRY}] Set Current Country Success`, props<{ currentCountry: { id: number, name: string, parentCodeCountry: string } }>());
export const setCurrentCountryFailure = createAction(`[${COUNTRY}] Set Current Country Failure`, props<{ errorMessage: string }>());

export const getCurrentCountryAction = createAction(`[${COUNTRY}] Get Current Country`);
